import { DateTime } from "../fundamental/DateTime";
import { UserName } from "../user/UserName";
import { InquiryStatus } from "./Inquiry";
import { InquiryCategory } from "./InquiryCategory";
import { InquiryContent } from "./InquiryContent";
import { InquiryId } from "./InquiryId";

const InquiryListItemType = Symbol();

export class InquiryListItem {
    [InquiryListItemType]: any;
    readonly id: InquiryId;
    readonly createdAt: DateTime;
    readonly userName: UserName | null;
    readonly category: InquiryCategory;
    readonly status: InquiryStatus;
    readonly content: InquiryContent;

    private constructor(
        id: InquiryId,
        createdAt: DateTime,
        userName: UserName | null,
        category: InquiryCategory,
        status: InquiryStatus,
        content: InquiryContent,
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.userName = userName;
        this.category = category;
        this.content = content;
        this.status = status;
    }

    static from(
        id: InquiryId,
        createdAt: DateTime,
        userName: UserName | null,
        category: InquiryCategory,
        status: InquiryStatus,
        content: InquiryContent,
    ): InquiryListItem {
        return new InquiryListItem(
            id,
            createdAt,
            userName,
            category,
            status,
            content,
        );
    }
}

export type InquiryListItemJson = {
    id: string,
    createdAt: string,
    userName: string | null,
    category: string,
    status: InquiryStatus,
    content: string
}
